module.exports = __webpack_public_path__ + "img/digital-io.f53022bc.png";